<template>
  <el-card>
    <unit-form @confirm="handleAddSubmit" />
  </el-card>
</template>

<script>
import UnitForm from "@/components/unit/UnitForm";
import {request} from "@/config/request";
export default {
  name: "UnitAdd",
  components: {UnitForm},
  data() {
    return {

    }
  },
  methods: {
    async handleAddSubmit(data) {
      try {
        await request(this.$api.intellectUnit.add, data);
        this.$message.success(this.$t("操作成功"));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped lang="scss">



</style>
